<template>

    <div>
        <cube-tab-bar v-model="selectedLabel" show-slider>
            <cube-tab v-for="item in tabs" :label="item.label" :key="item.label">
            </cube-tab>
        </cube-tab-bar>

        <component :videoInfo="videoInfo" :chapterList="chapterList" :is='selectedLabel==="简介"?"Summary":"Catalog" '>
        </component>

    </div>

    

</template>

<script>
//引入组件
import Summary from './Summary.vue'
import Catalog from './Catalog.vue'
export default {
    //声明组件
    components:{
        Summary,
        Catalog
    },
    //接收父组件传过来的属性
    props:{
        videoInfo:{
            type:Object,
            required:true
        },
        chapterList:{
            type:Array,
            required:true
        }
    },
    data(){
        return{
            selectedLabel:"简介",
            tabs:[
                {
                    label:"简介"
                },
                {
                    label:"目录"
                }
            ]
        }
    }
}
</script>